import { StyledTooltip } from "./styles"

interface Props {
  text?: string
  color?: string
  background?: string
  fontSize?: string
  children?: any
}

export function Tooltip({
  text,
  background = "rgba(0, 0, 0, 0.75)",
  color = "white",
  fontSize = "14px",
  children
}: Props) {

  return (
    <>
      {text ? (
        <StyledTooltip background={background} fontsize={fontSize} color={color}>
          <span className="tooltip-text">{text}</span>
          {children}
        </StyledTooltip>
      ) : (
        <>
          {children}
        </>
      )}
    </>
  )
}